import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { ReorderMediaPlaylistDto } from '@/types/dtos/media/request/reorder-media-playlist.dto.ts';
import type { MediaPlaylistDto } from '@/types/dtos/media/media-playlist.dto.ts';
import { patchMediaPlaylistInQueryCache } from '@/state/mutations/media/patch-media-playlist-cache.ts';
import { invalidateSimulationCueSheet } from '@/state/queries/player/use-get-simulation-cue-sheet';

export const useReorderMediaPlaylistMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, ...body }: ReorderMediaPlaylistDto & { playlistId: string }) => {
      const token = await getToken();
      return reorderMediaPlaylist(playlistId, body, token ?? '');
    },
    onSuccess: (updatedPlaylist) => {
      patchMediaPlaylistInQueryCache(queryClient, updatedPlaylist);
      void invalidateSimulationCueSheet(queryClient);
    },
  });
};

const reorderMediaPlaylist = async (
  playlistId: string,
  body: ReorderMediaPlaylistDto,
  token: string,
): Promise<MediaPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/media-playlists/${playlistId}/reorder`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body, token });
};
